import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    election2019HomeMixin
} from './vue/mixins/elections2019';


initMain([election2019HomeMixin], {}, []);
header();